const Haberler = resolve => {
    require.ensure(['../views/apps/haberler/Haberler'], () => {
        resolve(require('../views/apps/haberler/Haberler'))
    })
};

const HaberTanimla = resolve => {
    require.ensure(['../views/apps/haberler/HaberTanimla'], () => {
        resolve(require('../views/apps/haberler/HaberTanimla'))
    })
};
const HaberlerListe = resolve => {
    require.ensure(['../views/apps/haberler/HaberlerListe'], () => {
        resolve(require('../views/apps/haberler/HaberlerListe'))
    })
};

const HaberArsiv = resolve => {
    require.ensure(['../views/apps/haberler/HaberArsiv'], () => {
        resolve(require('../views/apps/haberler/HaberArsiv'))
    })
};
const HaberlerDuzenle = resolve => {
    require.ensure(['../views/apps/haberler/HaberlerDuzenle'], () => {
        resolve(require('../views/apps/haberler/HaberlerDuzenle'))
    })
};
const Kategori = resolve => {
    require.ensure(['../views/apps/haberler/kategori/Kategori'], () => {
        resolve(require('../views/apps/haberler/kategori/Kategori'))
    })
};
const KategoriTanimlama = resolve => {
    require.ensure(['../views/apps/haberler/kategori/KategoriTanimlama'], () => {
        resolve(require('../views/apps/haberler/kategori/KategoriTanimlama'))
    })
};
import Vue from 'vue'
Vue.component('BultenTanimla', HaberTanimla);
Vue.component('BultenListesi', HaberlerListe);
Vue.component('BultenDuzenle', HaberlerDuzenle);
Vue.component('BultenKategorileri', KategoriTanimlama);

import layouts from '../layout'

export default {
    path: '/haberler',
    name: 'haberler',
    component: Haberler,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'haberlertanimla',
            component: HaberTanimla,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'liste',
            name: 'haberlerliste',
            component: HaberlerListe,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'arsiv',
            name: 'haberlerarsiv',
            component: HaberArsiv,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }, {
            path: 'guncelleme',
            name: 'haberlerduzenle',
            component: HaberlerDuzenle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }, {
            path: 'kategori',
            name: 'kategori',
            component: Kategori,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            },
            children: [
                {
                    path: 'islem',
                    name: 'kategoriislem',
                    component: KategoriTanimlama,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        tags: ['app']
                    }
                }
            ]
        },
    ]
}
